module.exports = __webpack_public_path__ + "static/media/display-4@768.09eec6a7.png";